<template>
  <div class="mt-2">
    <p class="mb-1 text-muted small">
      Para ver un reporte general de <u>todos los clientes</u>, haga clic en el
      siguiente botón.
    </p>
    <button
      @click="handleAction()"
      :disabled="loading"
      type="button"
      class="btn btn-primary"
    >
      {{ loading ? "Enviando..." : "Enviar reporte" }}
    </button>
  </div>
</template>
<script>
import sysMsgs from "@/helpers/system.message";
import financeServices from "@/services/finance.services";

export default {
  name: "ClientStatusReportButton",
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    handleAction() {
      sysMsgs
        .getConfirm(`Se enviará un email con el reporte general de clientes.`, "info")
        .then((result) => {
          if (result.value) {
            this.sendReport();
          }
        });
    },
    sendReport() {
      this.loading = true;
      financeServices.sendClientStatusReport().then(() => {
          this.loading = false;
          sysMsgs.getDialog( "Tenga en cuenta que el reporte puede demorar varios minutos en llegar a su destino", "success" );
        }).catch((error) => {
          console.log( "Component: ClientStatusReportButton, FN: sendReport", error.message );
          this.loading = false;
          sysMsgs.getMessage("No se pudo enviar el reporte.","error");
        });
    },
  },
};
</script>